import {createContext} from 'react';

const DataGridContext = createContext();

export default DataGridContext;
